import React from 'react';
import {useIntl} from 'react-intl';
import Switch from '../../forecast-app/shared/components/switch/switch';
import {TICKET_NOTIF_ROWS, ticketPrefKey} from './ticketNotificationPrefRows';

export interface TicketNotificationSectionProps {
	prefs: Record<string, boolean>;
	disableInApp: boolean;
	disableEmail: boolean;
	onToggle: (key: string) => void;
}

/**
 * ACC-533: the "Tickets" section of the personal notification settings page.
 * 4 ticket notification types × 2 channels (in-app, email). Toggles persist via
 * the ticketing notification-prefs mutation (wired by the parent page). Column
 * locking mirrors Forecast's master in-app/email switches for visual consistency
 * (cosmetic only — the ticketing backend does not consult those master switches).
 */
export function TicketNotificationSection({prefs, disableInApp, disableEmail, onToggle}: TicketNotificationSectionProps) {
	const {formatMessage} = useIntl();
	return (
		<div className="advanced-section">
			<div className="section-header">
				<div className="column-description">{formatMessage({id: 'profile.notifications.ticket_section'})}</div>
				<div className="column-app">{formatMessage({id: 'common.app'})}</div>
				<div className="column-email">{formatMessage({id: 'common.email'})}</div>
			</div>
			{TICKET_NOTIF_ROWS.map((row, i) => {
				const inAppKey = ticketPrefKey(row.type, 'inApp');
				const emailKey = ticketPrefKey(row.type, 'email');
				return (
					<div key={'ticket-notif-' + i} className="slider-container">
						<div className="column-description">{formatMessage({id: row.labelKey})}</div>
						<div className="column-app">
							<Switch
								locked={disableInApp}
								checked={Boolean(prefs[inAppKey]) && !disableInApp}
								onChange={() => onToggle(inAppKey)}
								sliderWidth={38}
								sliderHeight={20}
							/>
						</div>
						<div className="column-email">
							<Switch
								locked={disableEmail}
								checked={Boolean(prefs[emailKey]) && !disableEmail}
								onChange={() => onToggle(emailKey)}
								sliderWidth={38}
								sliderHeight={20}
							/>
						</div>
					</div>
				);
			})}
		</div>
	);
}
